export enum InputAutocomplete {
  Off = 'off',

  Username = 'username',

  Email = 'email',

  Nickname = 'nickname',

  BirthdayDate = 'bday',

  BirthdayDay = 'bday-day',

  BirthdayMonth = 'bday-month',

  BirthdayYear = 'bday-year',

  Gender = 'sex',

  Telephone = 'tel',

  Url = 'url',

  Language = 'language',

  PasswordCurrent = 'current-password',

  PasswordNew = 'new-password',

  OneTimeCode = 'one-time-code',

  /**
   * First & Last Name
   * @type {InputAutocomplete.AddressName}
   */
  AddressName = 'name',

  AddressTitle = 'honorific-prefix',

  AddressFirstName = 'given-name',

  AddressFamilyName = 'family-name',

  AddressCompany = 'organization',

  AddressCity = 'city',

  AddressState = 'state',

  /**
   * Street + Housenumber
   * @type {InputAutocomplete.AddressStreet}
   */
  AddressStreet = 'street-address',

  AddressCountryCode = 'country',

  AddressCountry = 'country-name',

  AddressZip = 'postal-code',

  /**
   * Street-name. These should only be present if the "street-address" is not present.
   * @type {InputAutocomplete.AddressLineStreetName}
   */
  AddressLineStreetName = 'address-line1',

  /**
   * Street-number. These should only be present if the "street-address" is not present.
   * @type {InputAutocomplete.AddressLineStreetNumber}
   */
  AddressLineStreetNumber = 'address-line2',

  /**
   * Street-addition. These should only be present if the "street-address" is not present.
   * @type {InputAutocomplete.AddressLineStreetAddition}
   */
  AddressLineStreetAddition = 'address-line3',


  /**
   * The first administrative level in the address.
   * This is typically the province in which the address is located. In the United States, this would be the state. In Switzerland, the canton. In the United Kingdom, the post town.
   * @type {InputAutocomplete.AddressLevel1}
   */
  AddressLevel1 = 'address-level1',

  /**
   * The second administrative level, in addresses with at least two of them.
   * In countries with two administrative levels, this would typically be the city, town, village, or other locality in which the address is located.
   * @type {InputAutocomplete.AddressLevel2}
   */
  AddressLevel2 = 'address-level2',
  /**
   * The third administrative level, in addresses with at least three administrative levels.
   * @type {InputAutocomplete.AddressLevel3}
   */
  AddressLevel3 = 'address-level3',


  /**
   * The finest-grained administrative level, in addresses which have four levels.
   * @type {InputAutocomplete.AddressLevel4}
   */
  AddressLevel4 = 'address-level4',


}
